export * from './src/seating-v1-seating-reservation-seating-reservation.meta.js';
